import React, { useContext } from 'react';
import Swal from 'sweetalert2';
import { FaTimes } from 'react-icons/fa';
import { ReportContext } from '../ReportContext';

const MarkAsSpam = ({ reportId, refetch, setRefetch }) => {
  const { spamReport } = useContext(ReportContext);

  const handleMarkAsSpam = async () => {
    const confirmResult = await Swal.fire({
      title: 'Confirm Spam Classification',
      text: 'Are you sure you want to mark this report as spam?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, mark as spam',
      cancelButtonText: 'Cancel',
    });

    if (confirmResult.isConfirmed) {
      // Get any saved spam reason
      const savedReason = sessionStorage.getItem(`spamReason_${reportId}`) || '';

      const { value: notes } = await Swal.fire({
        title: 'Spam Reason',
        input: 'textarea',
        inputValue: savedReason, // prefill from sessionStorage
        // width: '50vw',
        inputLabel: 'Please provide a reason for marking as spam',
        inputPlaceholder: 'Type your reason here...',
        inputAttributes: {
          'aria-label': 'Spam reason',
          style: 'height:30vh;',
        },
        showCancelButton: true,
        confirmButtonText: 'Submit',
        cancelButtonText: 'Cancel',
        didOpen: () => {
          const textarea = Swal.getInput();
          if (textarea) {
            textarea.addEventListener('input', (e) => {
              sessionStorage.setItem(`spamReason_${reportId}`, e.target.value);
            });
          }
        },
        preConfirm: (value) => {
          if (!value || !value.trim()) {
            Swal.showValidationMessage('Spam reason cannot be empty');
          }
          return value;
        },
      });

      if (notes) {
        const formData = { report_id: reportId, notes };
        // console.log('Report marked as spam:', formData);

        const response = await spamReport(formData);
        // console.log('res:',response)
        if (response?.status === 'success') {
          // Remove saved reason from sessionStorage
          sessionStorage.removeItem(`spamReason_${reportId}`);
          setRefetch(!refetch)

          await Swal.fire({
            icon: 'success',
            title: 'Marked as Spam',
            text: 'The report has been successfully marked as spam.',
            confirmButtonColor: '#d33',
          });
        }
      }
    }
  };

  return (
    <button
      className="btn btn-outline-danger btn-sm"
      title="Mark as Spam"
      onClick={handleMarkAsSpam}
    >
      <FaTimes style={{ marginRight: 5 }} />
      Mark as Spam
    </button>
  );
};

export default MarkAsSpam;
